import React from 'react'
import { Helmet } from 'react-helmet-async'
import type { Metadata } from 'next'
import ServicePageTemplate, { ServicePageConfig } from '@/components/templates/ServicePageTemplate'

export const metadata: Metadata = {
  title: 'Black Car Service | Member Services | FGA Prestige',
  description: 'Premium luxury transportation with professional chauffeurs. Discreet, reliable ground transportation for discerning clients at FGA Prestige.',
  openGraph: {
    title: 'Black Car Service | Member Services | FGA Prestige',
    description: 'Premium luxury transportation with professional chauffeurs. Discreet, reliable ground transportation for discerning clients at FGA Prestige.',
    url: 'https://fgaprestige.com/member-services/black-car-service',
    images: [
      {
        url: '/Member Services/Black Car Service/hero.png',
        width: 1200,
        height: 630,
        alt: 'FGA Prestige Black Car Service',
      },
    ],
  },
}

const blackCarConfig: ServicePageConfig = {
  title: 'Black Car Service - FGA Prestige',
  description: 'Premium luxury transportation with professional chauffeurs.',
  slug: 'black-car-service',
  heroImage: '/Member Services/Black Car Service/hero.png',
  serviceName: 'BLACK CAR SERVICE',
  whySectionA: {
    title: 'Driven by Distinction',
    content: 'Step into a world where every journey is an event, and every arrival is an entrance. Our Black Car Service is more than just a ride—it’s a statement. Glide through the city in a luxury limousine, cocooned in plush leather, ambient lighting, and the quiet confidence that comes with traveling in style. Whether you’re headed to a gala or simply crossing town, we ensure your experience is as smooth as the ride itself.',
    image: '/Member Services/Black Car Service/body/1.png',
    imageAlt: 'Luxury Black Car Service'
  },
  whySectionC: {
    title: 'Your Personal Chauffeur',
    content: 'Meet your personal chauffeur: a consummate professional, always punctual, impeccably discreet, and attuned to your every need. Beyond expert navigation, your chauffeur is your city confidant—anticipating traffic, opening doors, and making sure your journey is seamless from start to finish. No request is too small, no detail overlooked. Safety, comfort, and privacy are not just promises—they’re our standard',
    image: '/Member Services/Black Car Service/body/2.png',
    imageAlt: 'Luxury Black Car Service'
  },
  whySectionB: {
    title: 'The City Is Your Playground ',
    benefits: [
      {
        title: 'Let Us Carry the Day',
        description: 'Imagine this: You’ve landed in a bustling metropolis. The shops beckon, the avenues await, and your only concern is which boutique to visit next.'
      },
      {
        title: '',
        description: 'As you indulge in a day of shopping, your chauffeur becomes your trusted companion—whisking you from flagship stores to hidden gems, collecting your bags with a practiced hand, and ensuring not a single parcel slows you down.'
      },
      {
        title: '',
        description: 'Luggage? Consider it handled. Shopping sprees? Effortless. While others juggle maps and suitcases, you glide from one adventure to the next, hands free and utterly unburdened.'
      }
    ],
    image: '/Member Services/Black Car Service/body/3.png',
    imageAlt: 'Premium Transportation Fleet'
  },
  masterpieceBackgroundImage: '/Member Services/Black Car Service/CTA Banner/banner.png'
}

export default function BlackCarServicePage() {
  return (
    <>
      <Helmet>
        <title>Black Car Service | Member Services | FGA Prestige</title>
        <meta name="description" content="Premium luxury transportation with professional chauffeurs. Discreet, reliable ground transportation for discerning clients at FGA Prestige." />
        <link rel="canonical" href="https://fgaprestige.com/member-services/black-car-service" />
        <meta property="og:title" content="Black Car Service | Member Services | FGA Prestige" />
        <meta property="og:description" content="Premium luxury transportation with professional chauffeurs. Discreet, reliable ground transportation for discerning clients at FGA Prestige." />
        <meta property="og:url" content="https://fgaprestige.com/member-services/black-car-service" />
        <meta property="og:image" content="/Member Services/Black Car Service/hero.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="FGA Prestige Black Car Service" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Black Car Service | Member Services | FGA Prestige" />
        <meta name="twitter:description" content="Premium luxury transportation with professional chauffeurs. Discreet, reliable ground transportation for discerning clients at FGA Prestige." />
        <meta name="twitter:image" content="/Member Services/Black Car Service/hero.png" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Black Car Service",
            "description": "Premium luxury transportation with professional chauffeurs. Discreet, reliable ground transportation for discerning clients at FGA Prestige.",
            "provider": {
              "@type": "Organization",
              "name": "FGA Prestige",
              "url": "https://fgaprestige.com"
            },
            "url": "https://fgaprestige.com/member-services/black-car-service",
            "image": "/Member Services/Black Car Service/hero.png"
          })}
        </script>
      </Helmet>
      <ServicePageTemplate config={blackCarConfig} />
    </>
  )
}